import { updateLocale } from '@americanexpress/one-app-ducks';
import { getIsSupportedLocale } from '@americanexpress/rerouter';
import { setTenancyLocale } from '../ducks/tenancyLocale';
import { moduleName } from '../constants';

const setInitialTenancyLocale = (store) => {
  const { getState, dispatch } = store;

  return async (_nextState, _replace, callback) => {
    const state = getState();
    const axpLocale = state.getIn(['browser', 'cookies', 'axplocale'], '');
    const activeLocale = state.getIn(['intl', 'activeLocale'], '');
    const tenancyLocale = state.getIn(['modules', moduleName, 'tenancyLocale', 'locale'], '');

    // if on first load
    if (!tenancyLocale) {
      // if axpLocale is not in use, and valid
      // update to using it as initial locale and store
      if (axpLocale !== activeLocale && getIsSupportedLocale(axpLocale)) {
        await dispatch(updateLocale(axpLocale));
        await dispatch(setTenancyLocale(axpLocale));

      // otherwise store the current active locale
      } else {
        await dispatch(setTenancyLocale(activeLocale));
      }
    }

    callback();
  };
};

export default setInitialTenancyLocale;
